import { createContext } from 'react'

export interface ListViewContextValue {
  selected: boolean
}

export const ListViewItemContext = createContext<ListViewContextValue>({
  selected: false
})
